import {Component} from '@angular/core';
import {Skeleton} from 'primeng/skeleton';

@Component({
  selector: 'du-config-overview-skeleton',
  imports: [Skeleton],
  templateUrl: './config-overview-skeleton.component.html',
  styleUrl: './config-overview-skeleton.component.scss',
})
export class ConfigOverviewSkeletonComponent {
  protected readonly Array = Array;
}
